var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    attrs: {
      title: _vm.$t("common.googleVerify"),
      visible: _vm.dialog,
      "close-on-click-modal": false,
      "before-close": _vm.resetForm,
      "append-to-body": "",
      width: "560px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialog = $event;
      }
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("p", {
    staticClass: "bind-tip"
  }, [_vm._v(_vm._s(_vm.$t("common.inputVerifyTip")))]), _c("el-form", {
    ref: "form",
    attrs: {
      model: _vm.form,
      "status-icon": "",
      rules: _vm.rules,
      size: "small",
      "label-width": "88px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: _vm.$t("common.captcha"),
      prop: "verification_code"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      type: "text",
      maxlength: 6,
      "show-word-limit": ""
    },
    model: {
      value: _vm.form.verification_code,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "verification_code", $$v);
      },
      expression: "form.verification_code"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary",
      size: "mini"
    },
    on: {
      click: _vm.close2FA
    }
  }, [_vm._v(_vm._s(_vm.$t("common.confirm")))]), _c("el-button", {
    attrs: {
      size: "mini"
    },
    on: {
      click: function click($event) {
        return _vm.resetForm("form");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))])], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };